import { expectResponse, requestFetch } from "@/transport/http"

export function localMode() {
  return typeof document !== "undefined" && document.querySelector('meta[name="mux-local"]')?.getAttribute("content") === "1"
}

export function localAccountPath(path: string) {
  const pathname = path.split("?", 1)[0]
  if (pathname === "/api/providers" || pathname.startsWith("/api/providers/") ||
      pathname === "/api/models" || pathname === "/api/ai/preferences" || pathname.startsWith("/api/ai/preferences/") ||
      pathname === "/api/ai/internal-prompts" || pathname === "/api/secrets" || pathname.startsWith("/api/secrets/") ||
      pathname.startsWith("/auth/") || pathname.startsWith("/provider/")) return `/api/local/account-api${path}`
  return path
}

export async function bootstrapLocalBrowser() {
  if (!localMode()) return
  const fragment = new URLSearchParams(location.hash.slice(1))
  const token = fragment.get("local_bootstrap")
  if (!token) return
  fragment.delete("local_bootstrap")
  history.replaceState(null, "", location.pathname + location.search + (fragment.size ? `#${fragment}` : ""))
  await expectResponse(await requestFetch("/api/local/session", {
    method: "POST", credentials: "same-origin",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }),
  }), { error: "Could not authorize this local browser. Run Kettle again to open it." })
}
